import * as React from 'react'
import * as S from './Toggle.styles'

const Toggle = ({
  as = 'span',
  active,
  size = 'small',
  disabled,
  fullWidth,
  ...props
}: ToggleProps & React.HTMLAttributes<HTMLElement>) => {
  return (
    <S.Toggle
      as={as}
      size={size}
      active={active}
      disabled={disabled}
      fullWidth={fullWidth}
      {...props}
    />
  )
}

export default Toggle

const ToggleCollapseContainer = ({
  children,
  multiLine = false,
  hidden = false,
  ...restProps
}: ToggleCollapseContainerProps) => {
  return (
    <S.ToggleCollapseContainer
      multiLine={multiLine}
      hidden={hidden}
      {...restProps}
    >
      {children}
    </S.ToggleCollapseContainer>
  )
}

Toggle.CollapseContainer = ToggleCollapseContainer

interface ToggleProps {
  as: 'label' | 'span'
  active?: boolean
  size?: 'small' | 'large'
  disabled?: boolean
  fullWidth?: boolean
}

interface ToggleCollapseContainerProps extends React.PropsWithChildren {
  multiLine?: boolean
  hidden?: boolean
}
